import { Grid, Icon, Paper, TextField, Typography, Button, Modal, Box, CircularProgress } from '@mui/material'
import React, { useRef, useState } from 'react'
import './resume.css'
import './button.css'
import emailjs from '@emailjs/browser';
import ResumeData from '../../utils/ResumeData'
import CustomTimeline, { CustomTimelineSeparator } from '../../components/Timeline/Timeline'
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import { TimelineContent, TimelineItem } from '@mui/lab';
import TimelineDot from '@mui/lab/TimelineDot';

const Resume = () => {
  const form = useRef();
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [failureTxt,setFailureTxt] = useState("");
  const [loading, setLoading] = useState(false);
  const isValidEmail = (email) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isValidPhoneNumber = (phoneNumber) => {
    // Regular expression for phone number validation
    const phoneRegex = /^09[0-9]{8}$/; // Matches 10 digits starting with '09'
  
    // Check if phone number matches the regex and consists only of digits
    if (!phoneRegex.test(phoneNumber)) {
      return false;
    }
  
    // Additional checks if needed (e.g., length)
  
    return true;
  };
  const sendEmail = (e) => {
    e.preventDefault();
    const formData = new FormData(form.current);
    const isFormValid = Array.from(formData.values()).every(value => !!value);
    if (!isFormValid) {
      setFailureTxt('Please fill in all fields.');
      setFailure(true);
      setTimeout(() => setFailure(false), 3000);
      return;
    }
    const email = formData.get('user_email');
    const phoneNumber = formData.get('user_number');
    if (!isValidEmail(email)) {
      setFailureTxt('Please enter a valid email address.');
      setFailure(true);
      setTimeout(() => setFailure(false), 3000);
      return;
    }
    if (!isValidPhoneNumber(phoneNumber)) {
      setFailureTxt('Please enter a valid phone number.09 ** ** ** **');
      setFailure(true);
      setTimeout(() => setFailure(false), 3000);
      return;
    }  
    setLoading(true);
    emailjs
      .sendForm('service_u27l74h', 'template_q4pzu6g', form.current, {
        publicKey: 'M-MqEg9g_y4iyrQ_v',
      })
      .then(
        () => {
          setLoading(false);
          console.log('SUCCESS!');
          setSuccess(true);
          setTimeout(() => setSuccess(false), 3000); // Hide success popup after 3 seconds
          form.current.reset();
        },
        (error) => {
          setLoading(false);
          console.log('FAILED...', error.text);
          setFailureTxt('FAILED...');
          setFailure(true);
          setTimeout(() => setFailure(false), 3000);
        },
      );
  };
  const Popup = ({ message }) => {
    return (
      <div className="popup">
        <span>{message}</span>
      </div>
    );
  };
  return (
    <>
    <Grid container className='section padding_bottom padding_top'>
      <Grid item className='section_title margin_bottom' >
      <span></span>
        <h6 variant='h6' className='text'>About Me</h6>
      </Grid>
      <Grid item xs={12}>
        <Typography className='aboutme' variant='body2'>{ResumeData.about}</Typography>
        </Grid>   
    </Grid>
    <Grid container className='section padding_bottom'>
       <Grid item className='section_title margin_bottom' >
        <span></span>
        <h6 variant='h6' className='text'>Resume</h6>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item sm={12} md={6}>
            <CustomTimeline title='Work Experience' icon={<WorkIcon/>}>
              {
                ResumeData.experiences?.map(experience => (
                  <TimelineItem key={experience.title}>
                    <CustomTimelineSeparator/>
                    <TimelineContent>
                      <Typography className='title'>{experience.title}</Typography>
                      <Typography variant='caption' className='company'>{experience.company}</Typography>
                      <Typography variant='caption' className='date'>{experience.date}</Typography>
                      <Typography variant='body2' className='decription'>{experience.description}</Typography>
                      {experience.link && <Typography variant='caption' className='link'><a href={experience.link} target='_blank' rel='noreferrer'>View Project</a></Typography>}
                    </TimelineContent>
                  </TimelineItem>
                ))
              }
            </CustomTimeline>
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTimeline title='Education' icon={<SchoolIcon/>}>
              {
                ResumeData.educations.map(education => (
                  <TimelineItem key={education.title}>
                    <CustomTimelineSeparator/>
                    <TimelineContent>
                      <Typography className='title'>{education.title}</Typography>
                      <Typography variant='caption' className='date'>{education.date}</Typography>
                      <Typography variant='body2' className='decription'>{education.description}</Typography>
                      {education.honors==null? <></>:<Typography className='honors'>{education.honors}</Typography>}
                    </TimelineContent>
                  </TimelineItem>
                ))
              }
            </CustomTimeline>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    <Grid container className='section padding_bottom'>
      <Grid item className='section_title margin_bottom' >
        <span></span>
        <h6 variant='h6' className='text'>My Services</h6>
      </Grid>
      <Grid item xs={12}>
        <Grid container className='services_main' >
          {
            ResumeData.services.map(service=>(
              <Grid xs={12} sm={6} md={3}>
                <div className='service'>
                  <div className='service_icon'>{service.icon}</div>
                  <Typography className='service_title' variant='h6'>{service.title}</Typography>
                  <Typography className='service_description' variant='body2'>{service.description}</Typography>
                </div>
              </Grid>
            ))
          }
        </Grid>
      </Grid>
    </Grid>
    <Grid container className='section graybg padding_bottom padding_50'>
    <Grid container className='section'>
      <Grid item xs={12}>
        <Grid container justifyContent='space-around' spacing={3}>
        {
            ResumeData.skills.map(skill => (
              <Grid item xs={12} sm={6} md={3}>
                <Paper elevation={0} className='skill' >
                  <Typography variant='h6' className='skill_title'>
                    {skill.title}
                  </Typography>
                  {skill.descriptions.map(description => (
                    <Typography variant='body2' className='skill_description'>
                      <TimelineDot variant='outlined' className='timeline_dot'/>
                      {description}
                    </Typography>
                  ))}
                </Paper>
              </Grid>
            ))
          }
        </Grid>
      </Grid>
    </Grid>
    </Grid>
    <Grid container className='section padding_top padding_bottom'>
          <Grid xs={12} lg={7} className="contact_form">
          <form ref={form} onSubmit={sendEmail}>
            <Grid container>
              <Grid item>
                <Grid item className='section_title margin_bottom' >
                    <span></span>
                    <h6 variant='h6' className='text'>Contact Form</h6>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField variant='standard' fullWidth name='user_name' label='Name'/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField variant='standard' fullWidth name='user_number' label='Phone Number' 
                        inputProps={{
                        type: 'number',
                        pattern: '^09[0-9]{8}$', // Restrict to 10 digits starting with '09'
                        maxLength: 10 // Limit input to 10 characters
                        }}/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField variant='standard' fullWidth name='user_email' label='Email'/>
                    </Grid>
                    <Grid item xs={12} >
                        <TextField variant='standard' fullWidth name='message' label='Message' multiline rows={3}/>
                    </Grid>
                    <Grid item xs={12}>
                    <Button className="btn" type="submit">
                            <span className='btn-text'>Submit</span>
                    </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            </form>

             {/* Success Modal */}
             <Modal open={success} onClose={() => setSuccess(false)}>
              <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 8 }}>
                <Typography variant="h6" component="h2">Success! Abrham will contact soon</Typography>
              </Box>
            </Modal>

            {/* Failure Modal */}
            <Modal open={failure} onClose={() => setFailure(false)}>
              <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 8 }}>
                <Typography variant="h6" component="h2">{failureTxt}</Typography>
              </Box>
            </Modal>

            {/* Loading Modal */}
            <Modal open={loading} onClose={() => setLoading(false)}>
              <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'transparent', boxShadow: 'none', p: 4 }}>
                <CircularProgress />
              </Box>
            </Modal>

          </Grid>
          <Grid xs={12} lg={5}>
            <Grid container>
              <Grid item className='section_title margin_bottom' >
                    <span></span>
                    <h6 variant='h6' className='text'>Contact Information</h6>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={12}>
                      <Typography className='contact_info'>
                        <span>Address: </span>
                        {ResumeData.address}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className='contact_info'>
                        <span>Phone: </span>
                        {ResumeData.phoneNumber}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className='contact_info'>
                        <span>Email: </span>
                        {ResumeData.email}
                      </Typography>
                    </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container className='contact_info_socialContainer'>
                {
                Object.keys(ResumeData.socials).map(key=>
                    ( 
                    <Grid item className='contact_info_social'>
                      <a href={ResumeData.socials[key].link}>{ResumeData.socials[key].icon}</a>
                    </Grid>
                    ))
                     }
                </Grid>
              </Grid>
            </Grid>
          </Grid>
    </Grid>
    </>
  )
}

export default Resume